export const UPDATE_LOADING_EVENTS = 'UPDATE_LOADING_EVENTS';
export const UPDATE_LOADING_EVENT = 'UPDATE_LOADING_EVENT';
export const UPDATE_ERROR_EVENTS = 'UPDATE_ERROR_EVENTS';
export const CREATE_EVENTS = 'CREATE_EVENTS';
export const CREATE_EVENT = 'CREATE_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';